<template>
	<div>
		<!-- <top></top> -->
		<div class="conmtont">
			<div class="flex align-center justify-between padding-sm bg-white margin-tb">
				<!-- <p class="text-sm text-666">首页 - 找工作</p>
				<p class="flex align-center text-999 text-sm pointer" @click="back()">
					<i class="el-icon-back"></i>
					<span>返回</span>
				</p> -->
				<el-breadcrumb separator-class="el-icon-minus">
				  <el-breadcrumb-item :to="{ path: '/' }"><span class="text-sm text-666">首页</span></el-breadcrumb-item>
				  <el-breadcrumb-item><span class="text-sm text-666">找工作</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="bg-white padding-sm margin-bottom-sm">
				<div class="flex margin-bottom-sm">
					<p class="titla text-left text-xs text-666">工 种：</p>
					<p class="flex-sub text-left">
						<span class="margin-right-sm margin-bottom-sm text-xs  pointer pro-item" @click="choseprofession(item)" :class="workCategroyId == item.id?'text-theme':'text-666'" v-for="(item,index) in profession" :key="index">{{item.work_categroy_name}}</span>
					</p>
				</div>
				<div class="flex margin-bottom-sm">
					<p class="titla text-left text-xs text-666">城 市：</p>
					<p class="flex-sub text-left">
						<span class="margin-right-sm  text-xs  pointer pro-item" @click="choseprovince(item,index)" :class="provinceIndex == index?'text-theme':'text-666'" v-for="(item,index) in provinceList" :key="index">{{item.name}}</span>
					</p>
				</div>
				<div class="flex">
					<p class="titla text-left text-xs text-666">排序方式：</p>
					<p class="flex-sub text-left">
						<span class="margin-right-sm  text-xs pointer pro-item" @click="chose(item,index)" :class="sortId == item.id?'text-theme':'text-666'" v-for="(item,index) in sort" :key="index">{{item.name}}</span>
					</p>
				</div>
			</div>
			<div class="flex">
				<div class="flex-sub">
					<div v-if="total != 0">
						<div v-for="(item,indx) in workList" :key="indx">
							<StationList :data="item" :width="786" :height="184" :size="24"></StationList>
							
						</div>
						<div class="pagination">
							<el-pagination
							 @current-change="handleCurrentChange"
							  background
							  page-size="9"
							  layout="prev, pager, next"
							  prev-text="上一页"
							  next-text="下一页"
							   :total="total"
							  >
							</el-pagination>
						</div>
					</div>
					<div class="text-center" v-else>
						<el-empty description="暂无数据"></el-empty>
					</div>
				</div>
				<div class="margin-left" v-if="newList.length != 0">
					<div class="flex align-center justify-between margin-bottom-sm">
						<p class="title padding-left-sm">最新招工</p>
					</div>
					<div v-for="(item,indx) in newList" :key="indx">
						<StationList :data="item" :width="387" :height="168" :size="18"></StationList>
					</div>
				</div>
			</div>
		</div>
		<right type="1"></right>
		<router-view />
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	import Right from '@/components/public/right.vue';
	import Top from '@/components/public/top.vue';
	import StationList from '@/components/list/station-list.vue';
	export default {
		components: {
			Top,
			Right,
			StationList,
		},
		name: '',
		data() {
			return {
				provinceIndex:0,//
				profession:[],//工 种
				provinceList:[],//城 市
				sort:[],//排序方式
				sortId:0,//
				page:1,
				workList:[],//全部列表
				workCategroyId:0,//
				newList:[],//最新
				total:0,//
			}
		},
		created() {
			//通知听不状态栏 选中的页面
			Bus.$emit('chosename','worker')
			this.getSortlist()
			this.getworkCategroy()
			this.getWorkList()
			this.getcity()
		},
		methods: {
			
			//获取城市列表
			getcity(){
				this.ajax('get', '/api/work/getCityList', {}, res => {
					if(res.status == 200){
						let list = res.data;
						let obj = {
							id: 0,
							level: 2,
							pid: 0,
							name: '不限',
						}
						list.unshift(obj)
						this.provinceList = list;
						console.log(this.provinceList);
					}
				})
			},
			//城市筛选
			choseprovince(item,index){
				this.provinceIndex = index
				this.cityname = item.name
				this.page = 1
				this.getWorkList()
				this.getnewList()
			},
			back(){
				this.$router.back()
			},
			/**
			 * 获取首页用工分类
			 * */
			getworkCategroy(){
				this.ajax('get', '/api/pc/workCategroy/getlist', {
					type:1
				}, res => {
					if(res.status == 200){
						let arr = {
							id:0,
							work_categroy_name:'全部',
						}
						res.data.unshift(arr)
						this.profession= res.data
					}
				})
			},
			getSortlist(){
				this.ajax('get', '/api/work/getSort', {}, res => {
					if(res.status == 200){
						this.sort= res.data
						this.sortId = res.data[0].id
					}
				})
			},
			choseprofession(item){
				this.workCategroyId = item.id
				this.page = 1
				this.getWorkList()
			},
			handleCurrentChange: function(currentPage) {
			  this.page = currentPage;
			  this.getWorkList();
			},
			/**
			 * 获取招聘岗位
			 * */
			getWorkList(){
				this.ajax('get', '/api/work/getWorkList', {
					area:this.provinceIndex == 0?'':this.cityname,
					page:this.page,
					workCategroyId:this.workCategroyId,
					sortId:this.sortId
				}, res => {
					if(res.status == 200){
						this.workList = res.data.data
						// this.pageSize = res.data.lastpage
						if(this.page == 1){
							this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
						}
					}
				})
			},
			/**
			 * 获取最新招聘岗位
			 * */
			getnewList(){
				this.ajax('get', '/api/pc/work/getWorkList', {
					area:this.provinceIndex == 0?'':this.cityname,
					page:1,
				}, res => {
					if(res.status == 200){
						this.newList = res.data.data
					}
				})
			},
			/**
			 * 筛选
			 * list Array  要筛选的列表 
			 * item object 选中的筛选
			 * */
			chose(item,index){
				this.sortId = item.id
				this.page = 1
				this.getWorkList()
			}
		}
	}
</script>

<style scoped lang="less">
	.titla{
		width: 80px;
		word-spacing:25px;
	}
	.title{
		position: relative;
		font-size: 22px;
		&:before{
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 6px;
			height: 26px;
			background: #09827B;
			content: '';
			
		}
	}
	.pro-item:hover{
		color: #09827B;
	}
	/deep/ .el-pagination.is-background .btn-next,/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .el-pager li{
		background: #fff !important;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
		background:#09827B !important;
		color: #fff !important;
	}
	/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .btn-next{
		padding: 0 10px;
	}
	
	.pagination{
		margin: 59px 0;
	}
</style>



// WEBPACK FOOTER //
// src/view/index/worker.vue